var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedCaption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 46,
    viewBox: "0 0 62 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8571 33.7142H17.1429C16.0062 33.7142 14.9161 33.2627 14.1124 32.4589C13.3086 31.6552 12.8571 30.5651 12.8571 29.4285V16.5714C12.8571 15.4347 13.3086 14.3446 14.1124 13.5409C14.9161 12.7371 16.0062 12.2856 17.1429 12.2856H27.8571V16.5714H17.1429V29.4285H27.8571V33.7142Z",
    fill: "#003E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2857 33.7142H38.5714C37.4348 33.7142 36.3447 33.2627 35.541 32.4589C34.7372 31.6552 34.2857 30.5651 34.2857 29.4285V16.5714C34.2857 15.4347 34.7372 14.3446 35.541 13.5409C36.3447 12.7371 37.4348 12.2856 38.5714 12.2856H49.2857V16.5714H38.5714V29.4285H49.2857V33.7142Z",
    fill: "#003E9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7143 44.4287H4.28571C3.14907 44.4287 2.05899 43.9772 1.25526 43.1734C0.451529 42.3697 0 41.2796 0 40.143V5.85725C0 4.7206 0.451529 3.63052 1.25526 2.82679C2.05899 2.02306 3.14907 1.57153 4.28571 1.57153H55.7143C56.8509 1.57153 57.941 2.02306 58.7447 2.82679C59.5485 3.63052 60 4.7206 60 5.85725V40.143C60 41.2796 59.5485 42.3697 58.7447 43.1734C57.941 43.9772 56.8509 44.4287 55.7143 44.4287ZM4.28571 5.85725V40.143H55.7143V5.85725H4.28571Z",
    fill: "#003E9C",
    stroke: "white",
    strokeWidth: 2.14286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedCaption);
export default __webpack_public_path__ + "static/media/closedCaption.ae21bfe327789ee685be8c8ce6497d0a.svg";
export { ForwardRef as ReactComponent };